

























































































import { Mixins, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import Pagination from '@/components/Pagination.vue';
import ApiKeyModule from '@/store/modules/ApiKey';
import AuthModule from '@/store/modules/Auth';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';

@Component({
  components: {
    Table,
    Pagination,
  },
})
export default class SeamlessKey extends Mixins(ErrorHandleMixin, PaginationMixin) {
  TableHead = [
    [
      {
        text: 'No',
      },
      {
        text: 'Agent',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Partner',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Secret',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'URL',
        attr: {
          class: 'text-left',
        },
      },
      // {
      //   text: 'ID',
      // },
      // {
      //   text: 'Timestamp',
      // },
      {
        text: 'Edit',
      },
    ],
  ];

  ApiKeyInstance = getModule(ApiKeyModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  searchText = '';

  editModel = {
    url: '',
    _id: '',
    partner: '',
    agent: '',
  };

  data = [];

  PaginationDetail = {
    current: 1,
    amount: 0,
    size: 100,
  }

  created() {
    this.fetchKey();
  }

  changePage(i) {
    this.PaginationDetail.current = i;
    this.calPagination({ ...this.paginationParams });
    this.fetchKey();
  }

  async fetchKey() {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.ApiKeyInstance.FetchSeamlessKey();
    if (res.code) {
      this.checkError(res);
    }
    this.WinLoseList = {
      data: this.ApiKeyInstance.listSeamlessKey,
      pageAmount: Math.ceil(res.length / 100),
    };
    await this.calPagination({
      instance: 'WinLoseList',
      dataKey: 'data',
    });
    this.data = this.dataList;
    this.GeneralInstance.toggleLoading(false);
  }

  handleSearch() {
    this.data = this.ApiKeyInstance.listSeamlessKey
      .filter((item) => item.agent
        && item.agent.toLowerCase().includes(this.searchText.toLowerCase()));
  }

  handleEdit(item) {
    const {
      _id, url, partner, agent,
    } = item;
    this.editModel._id = _id;
    this.editModel.url = url;
    this.editModel.partner = partner;
    this.editModel.agent = agent;
  }

  handleCancel() {
    this.editModel = {
      url: '',
      _id: '',
      partner: '',
      agent: '',
    };
  }

  async handleSave() {
    const res = await this.ApiKeyInstance.UpdateSeamlessKey(this.editModel);
    this.checkError(res);
    await this.fetchKey();
    this.handleCancel();
  }
}
